module.exports = __webpack_public_path__ + "static/discoball-compressor-c498977c8c373cd426ac8ae801310aef.png";